<template>
  <div class="appNav-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item title="选中效果设置" name="1">
          <div>
            <color-picker class="mt16" :color.sync="activeLinkColor" title="单元格选中色" />
            <color-picker class="mt16" :color.sync="primaryLinkColor" title="单元格默认色" />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
export default {
  name: "appNav-options-setting",
  props: { options: Object },
  data() {
    return {
      activeNames: ["1"],
      countCol: 1
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    activeLinkColor: {
      get() {
        return this.options.activeLinkColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeLinkColor", false)
      }
    },
    primaryLinkColor: {
      get() {
        return this.options.primaryLinkColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "primaryLinkColor", false)
      }
    }
  }
}
</script>

<style scoped >
</style>
